import React from 'react'
import {
	GeneralContentWrapper,
	GeneralTitle
} from '../../components/Shared/GeneralComponents'

const HomePageTeam = () => {
	return (
		<GeneralContentWrapper>
			<GeneralTitle text="Team homepage" />
		</GeneralContentWrapper>
	)
}

export default HomePageTeam
